/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Unit_Per_MtokInputs */



/**
* | output |
* | --- |
* | "Prices shown per 1 million tokens." |
*
* @param {Model_Pricing_Unit_Per_MtokInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_unit_per_mtok = /** @type {((inputs?: Model_Pricing_Unit_Per_MtokInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Unit_Per_MtokInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Preise pro 1 Million Tokens.")
	return /** @type {LocalizedString} */ ("Prices shown per 1 million tokens.")
});